<template>
    <div>
        <div class="wrapper-page">
            <div class="card">
                <div class="card-body">
                    <h3 class="text-center m-0">
                        <a class="logo logo-admin" href="javascript:void(0);">
                            <img alt="logo" height="30" src="/images/logo/foundri-logo.png"/>
                        </a>
                    </h3>
                    <div class="p-3">
                        <form @submit.prevent="submit" class="form-horizontal m-t-30">
                            <div class="form-group">
                                <label>Email</label>
                                <input :class="{ 'parsley-error' : form.errors.has('email') }"
                                       class="form-control"
                                       placeholder="Enter email"
                                       type="text"
                                       v-model="form.email">
                                <ul :class="{'filled' : form.errors.has('email')}"
                                    class="parsley-errors-list">
                                    <li class="parsley-required">
                                        {{ form.errors.get('email') }}
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group row mt-4">
                                <div class="col-4">
                                    <router-link :to="{ name: Routes.login }"
                                                 class="text-muted"
                                                 tag="a">
                                        <i class="mdi mdi-login"/>
                                        Go to Login
                                    </router-link>
                                </div>
                                <div class="col-8 text-right">
                                    <button :disabled="form.busy"
                                            class="btn btn-primary w-md waves-effect waves-light"
                                            type="submit">
                                        Send Password Reset Link
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";

    export default {
        data() {
            return {
                Routes,
                form: new Form({
                    email: null
                }, {
                    email: 'required|email'
                })
            }
        },
        methods: {
            submit() {
                this.form.validate()
                    .then(() => {
                        App.post('/password/email', this.form)
                            .then(() => {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Successfully sent email reset link. Check your mail.',
                                    type: 'success'
                                });
                            })
                    });
            }
        }
    }
</script>

<style scoped>

</style>
